// Lenis smooth scrolling, synced to ScrollTrigger.
// Wheel is smoothed; touch stays native (Lenis default). Skipped entirely
// for users who prefer reduced motion.
import Lenis from 'lenis';
import { gsap, ScrollTrigger } from './gsap';

let lenis = null;

export function reducedMotion() {
	return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

export function initScroll() {
	if (reducedMotion()) {
		return null;
	}

	lenis = new Lenis({ autoRaf: false });

	// One clock: gsap's ticker drives Lenis, Lenis drives ScrollTrigger.
	lenis.on('scroll', ScrollTrigger.update);
	gsap.ticker.add((time) => lenis.raf(time * 1000));
	gsap.ticker.lagSmoothing(0);

	// Route same-page anchor clicks through Lenis.
	document.addEventListener('click', (event) => {
		const anchor = event.target.closest('a[href^="#"]');

		if (anchor && anchor.hash.length > 1 && document.querySelector(anchor.hash)) {
			event.preventDefault();
			lenis.scrollTo(anchor.hash, { offset: 0 });
		}
	});

	return lenis;
}

export function getLenis() {
	return lenis;
}

export function scrollToTop(immediate = true) {
	if (lenis) {
		lenis.scrollTo(0, { immediate, force: true });
	} else {
		window.scrollTo(0, 0);
	}
}

export function stopScroll() {
	if (lenis) lenis.stop();
}

export function startScroll() {
	if (lenis) lenis.start();
}
